/**
 * Created by Ivo Mehide <ivo@degeetia.ee> on 02.06.17.
 */

import React from "react";
import PropTypes from "prop-types";
import _ from "underscore";
import BasePageFrame from "./BasePageFrame";

class Splitted extends BasePageFrame {
    static propTypes = {
        params: PropTypes.shape({
            path: PropTypes.string.isRequired,
            resource: PropTypes.string.isRequired,
            action: PropTypes.oneOf(["list","new","view","edit","delete"]).isRequired,
            id: PropTypes.string,
            query: PropTypes.object,
            tab: PropTypes.string,
            parentPath: PropTypes.string,
            parentResource: PropTypes.string,
            parentAction: PropTypes.oneOf(["list","new","view","edit","delete"]),
            parentId: PropTypes.string,
            parentField: PropTypes.string,
            parentTab: PropTypes.string,
            isModal: PropTypes.bool
        }).isRequired,
        location: PropTypes.object.isRequired,
        router: PropTypes.object.isRequired,
        route: PropTypes.object.isRequired,
        options: PropTypes.shape({
            component: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]).isRequired,
            schema: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)])
        }).isRequired
    };

    static defaultProps = {};

    renderBody() {
        let items = this.getPageComponents();
        if (items == null || items.length == 0) return null;
        let i = 0;
        return _.map(items, (item) => {
            return (
                <div key={i++} className="row">
                    <div className="col-lg-12">
                        <div className="ibox m-b-sm">
                            {item}
                        </div>
                    </div>
                </div>
            );
        });
    }
}

export default Splitted;
